// Module
var code = "<a type=\"button\" class=\"btn btn-xs btn-link btn-filter btn-reset-filters padding-0 margin-0\" ng-click=\"$ctrl.eraseAllFilters()\" uib-tooltip=\"{{ 'EFFACER_TOUS_FILTRES' | translate }}\" tooltip-placement=\"left\"> <span class=\"glyphicon glyphicon-refresh\"></span> </a>";
// Exports
module.exports = code;